import axios from 'axios'
import qs from 'qs'

export default {
  loadDialogs: function(request) {
    //return axios.get('/api/message/dialogs', {params: request});
    return axios.get('/api/message/dialogs', {
      params: request,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
    });
  },
  loadMessages: function (request) {
    return axios.get('/api/message/messages', {params: request});
  },
  postMessage: function (data) {
    return axios.post('/api/message/create', data);
  },
  getUnreadMessageCount: function(dialogId) {
    let url = '/api/message/unreadmessagecount';
    if (dialogId) {
      url += `?dialogId=${dialogId}`;
    }
    return axios.get(url, {});
  },
  readMessage: function (id) {
    return axios.post(`/api/message/readmessage/${id}`, {});
  }
}